module.exports = __webpack_public_path__ + "static/media/TX22.3ad89a13.jpg";